var $ = require("jquery");

(function () {
  let $header = $("#Header");
  let $breadcrumbs = $(".Breadcrumbs")
  let $headerNav = $("#HeaderNav");
  let $menuToggle = $("#MenuToggle");
  let $megaMenu = $("#MegaMenu");
  let $headerVMA = $("#headerVMA");
  let $submenuToggle = $megaMenu.find(".js-toggle");
  let $html = $("body");
  let $menu = $(".Header-menuDropdown");
  let $dropdownGroups = $(".Header-menuLinkItem--dropdown");

  $menuToggle.on('click', function (e) {
    e.preventDefault();
    $html.toggleClass("-preventscroll")
    if ($header.hasClass("drop-down-header")) {
      $header.removeClass("drop-down-header");
    };
    $menu.each(function () {
      if ($(this).hasClass("visible")) {
        $(this).removeClass("visible")
      };
    });
    $menuToggle.toggleClass("-open");
    $headerNav.toggleClass("-open");
    $headerVMA.toggleClass("-open");
  });

  $submenuToggle.on("click", function (e) {
    e.preventDefault();
    $(this).parent().parent().toggleClass("-expanded");
  });

  //Init
  var prevScrollpos = window.pageYOffset;
  if (prevScrollpos > 0) {
    $header.addClass("-solid");
  }

  window.onscroll = function () {
    var currentScrollPos = window.pageYOffset;

    if (currentScrollPos > 0 || $headerVMA.length > 0) {
      $header.addClass("-solid");
      $breadcrumbs.addClass("-index");
    }
    else {
      $header.removeClass("-solid");
      $breadcrumbs.removeClass("-index");
    }

    if (prevScrollpos > currentScrollPos || currentScrollPos >= 0) {
      $header.removeClass("-hide")
    } else {
      $header.addClass("-hide")
    }

    prevScrollpos = currentScrollPos;
  }

  $dropdownGroups.each(function () {
    let $group = $(this);
    let $btn = $group.find(".drop-down-btn");
    let $border = $group.find(".drop-down-border");
    let $menu = $group.find(".Header-menuDropdown");
    let $items = $group.find(".drop-down-item");
    let $children = $group.find(".drop-down-childitems");
    let $childGroups = $group.find(".child-group"); // Select child groups

    $btn.on("click", function (event) {
      event.preventDefault();

      // Close other dropdowns
      $dropdownGroups.not($group).each(function () {
        let $other = $(this);
        $other.find(".drop-down-btn").removeClass("--active");
        $other.find(".drop-down-border").removeClass("--active");
        $other.find(".Header-menuDropdown").removeClass("visible");
        $other.find(".drop-down-item").removeClass("--active");
        $other.find(".drop-down-childitems").removeClass("--active");
        $other.find(".child-group").hide(); // Hide other child groups
      });

      // Toggle current
      $btn.toggleClass("--active");
      $menu.toggleClass("visible");
      $border.toggleClass("--active");
      $header.toggleClass("drop-down-header", $menu.hasClass("visible"));

      // Reset child states inside this dropdown
      $items.removeClass("--active");
      $children.removeClass("--active");
      $childGroups.hide(); // Hide all child groups in this dropdown

      // Open first item
      if ($menu.hasClass("visible")) {
        let $firstItem = $group.find(".drop-down-item").first(); // First node item
        $firstItem.toggleClass("--active");
        let firstParentId = $firstItem.closest("li").data("parent-id"); // Get parent ID
        $group.find(`[data-child-id="${firstParentId}"]`).show(); // Show corresponding child group
      }
    });

    $items.on("click", function (event) {
      event.preventDefault();

      let $item = $(this);
      let $itemParent = $item.closest("li");
      let $childList = $itemParent.find(".drop-down-childitems");
      let parentId = $itemParent.data("parent-id"); // Get parent ID

      // Reset others inside this group
      $items.removeClass("--active");
      $children.removeClass("--active");
      $childGroups.hide(); // Hide all child groups in this dropdown

      // Toggle selected
      $item.toggleClass("--active");
      $childList.toggleClass("--active");

      // Show the specific child group for the clicked parent
      $group.find(`[data-child-id="${parentId}"]`).toggle(); // Show/hide the matching child group
    });
  });
})();